import { useQuery } from 'react-query';
import { getAccountDetails, getAccounts } from '@/services/accounts';

export const useGetAccounts = ({
	page = 1,
	limit = 50,
	search = '',
	sort = '',
	enabled = true,
	ids = [],
}: {
	page?: number;
	limit?: number;
	search?: string;
	sort?: string;
	enabled?: boolean;
	ids?: string[];
}) => {
	return useQuery({
		queryKey: ['accounts', page, limit, search, sort, ids],
		queryFn: () => getAccounts(page, limit, search, sort, ids),
		enabled,
		keepPreviousData: false,
		// staleTime: 5 * 60 * 1000, // 5 minutes
		// cacheTime: 10 * 60 * 1000, // 10 minutes
	});
};

export const useGetAccountDetails = ({
	accountId,
	enabled = true,
}: {
	accountId: string | null | undefined;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['account-details', accountId],
		queryFn: () => getAccountDetails(accountId as string),
		enabled: enabled && !!accountId,
		// staleTime: 5 * 60 * 1000, // 5 minutes
		// cacheTime: 10 * 60 * 1000, // 10 minutes
	});
};

